import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { injectAnalytics } from "../lib/track";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [content, setContent] = useState(() => window.__FL_CONTENT__ || null);
  const [weddings, setWeddings] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [gallery, setGallery] = useState({ items: [], categories: [] });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [c, w, t, g] = await Promise.all([
        api.get("/content"),
        api.get("/weddings"),
        api.get("/testimonials"),
        api.get("/gallery"),
      ]);
      setContent(c.data);
      setWeddings(w.data);
      setTestimonials(t.data);
      setGallery(g.data);
      if (c.data?.analytics) injectAnalytics(c.data.analytics);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteContext.Provider value={{ content, weddings, testimonials, gallery, loading, refresh: load }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
